import React from 'react';
import { Box, Typography, Grid } from '@availity/element';
import { colors } from '../../../static/constants/theme';

const logos = [
  { src: '/static/assets/logos/AtriumHealth.svg', alt: 'Atrium Health' },
  { src: '/static/assets/logos/BlueCross.svg', alt: 'Blue Cross' },
  { src: '/static/assets/logos/hcsc.svg', alt: 'HCSC' },
  { src: '/static/assets/logos/Humana.svg', alt: 'Humana' },
  { src: '/static/assets/logos/Piedmont.svg', alt: 'Piedmont' },
  { src: '/static/assets/logos/Radnet.svg', alt: 'Radnet' },
];

const LogoGrid = () => (
  <Box 
    className="logo-grid" 
    sx={{ 
      py: { xs: 4, md: '56px' }, 
      px: { xs: 2, md: 0 },
      position: 'relative',
      background: colors.background.dark,
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(/static/assets/backgrounds/logo-grid-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.1,
        zIndex: 0,
      },
      borderTop: '1px solid transparent',
      borderBottom: '1px solid transparent',
      borderImage: 'linear-gradient(90deg, rgba(18, 67, 131, 0) 0%, #124383 49.52%, rgba(18, 67, 131, 0) 100%) 1',
      display: 'flex',
      flexDirection: 'column',
      gap: { xs: 3, md: '32px' },
    }}
  >
    <Typography className="logo-grid__title" sx={{ fontSize: 18, lineHeight: 1.444, fontWeight: 400, px: { xs: 2, md: 0 }, color: colors.text.light, textAlign: 'center', position: 'relative', zIndex: 1 }}>
      Trusted by Healthcare Professionals Everywhere
    </Typography>
    <Grid
      className="logo-grid__container"
      container
      justifyContent="center"
      spacing={{ xs: 3, sm: 5, md: 7 }}
      sx={{
        maxWidth: '1536px',
        margin: '0 auto',
        width: '100%',
        position: 'relative',
        zIndex: 1,
        height: { md: '45px' },
        opacity: 1,
      }}
    >
      {logos.map((logo) => (
        <Grid item key={logo.src}>
          <Box component="img" className="logo-grid__logo" {...logo} />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default LogoGrid;